import React from "react";

import play from "../../Assets/Images/playstore.png";
import apple from "../../Assets/Images/apple.png";
import mixpanel from "mixpanel-browser";

// "Get the app" box with App Store and Play Store links.
// `compact` hides the label on small screens (used in the header).
// `location` is sent to Mixpanel so we can tell which CTA was clicked.
const GetTheApp = ({ className = "", compact = false, location }) => {
  return (
    <div
      className={`w-fit ${
        compact ? "h-[46px] sm:h-[56px] px-2 sm:px-4" : "h-[56px] px-4"
      } 3xl:h-[62px] rounded-[10px] bg-[#6935D3] flex justify-center gap-3 sm:gap-4 items-center ${className}`}
    >
      <h4
        className={`${
          compact ? "hidden sm:block" : ""
        } text-[#FFF] font-[500] text-[18px] 3xl:text-[20px] tracking-[-1%] whitespace-nowrap`}
      >
        Get the app
      </h4>

      <div className="flex items-center justify-center gap-2">
        <a
          target="_blank"
          rel="noreferrer"
          aria-label="Download on the App Store"
          href={"https://apps.apple.com/ng/app/halvest/id6738990294"}
          onClick={() => {
            mixpanel.track("Website-AppStore-Button Clicked", { location });
          }}
          className="transition duration-[500ms] ease-in-out hover:scale-[95%]"
        >
          <img
            src={apple}
            alt="App Store"
            className={`${compact ? "w-[34px] h-[34px] sm:w-[40px] sm:h-[40px]" : "w-[40px] h-[40px]"} 3xl:w-[44px] 3xl:h-[44px] cursor-pointer`}
          />
        </a>
        <div className="h-[11px] w-[0.6px] bg-[#FFFFFF]"></div>
        <a
          target="_blank"
          rel="noreferrer"
          aria-label="Get it on Google Play"
          href={"https://play.google.com/store/apps/details?id=com.halvestco"}
          onClick={() => {
            mixpanel.track("Website-PlayStore-Button Clicked", { location });
          }}
          className="transition duration-[500ms] ease-in-out hover:scale-[95%]"
        >
          <img
            src={play}
            alt="Google Play"
            className={`${compact ? "w-[34px] h-[34px] sm:w-[40px] sm:h-[40px]" : "w-[40px] h-[40px]"} 3xl:w-[44px] 3xl:h-[44px] cursor-pointer`}
          />
        </a>
      </div>
    </div>
  );
};

export default GetTheApp;
